/**
 * GetUserPreferencesQuery - Fetches current user's preferences
 * Follows MediatR pattern (Query + Handler in same file)
 */

import type { IQuery, IQueryHandler, IHttpClient, BaseApiResponse } from '@/application/core';
import { toCamelCase } from '@/utils/caseTransform';
import type { UserPreferences } from './user-preferences.types';

// ============================================================================
// Query (Request)
// ============================================================================

export class GetUserPreferencesQuery implements IQuery<UserPreferences> {
  readonly type = 'GetUserPreferencesQuery' as const;
}

// ============================================================================
// Handler
// ============================================================================

export class GetUserPreferencesQueryHandler
  implements IQueryHandler<GetUserPreferencesQuery, UserPreferences>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(_query: GetUserPreferencesQuery): Promise<UserPreferences> {
    const response = await this.httpClient.get<BaseApiResponse<any>>(
      '/api/v1/user/preferences'
    );

    if (!response.succeeded) {
      throw new Error(response.message || 'Failed to fetch user preferences');
    }

    return toCamelCase(response.data ?? {});
  }
}
